/**
 * @generated SignedSource<<09165bedf207367c660bd56c4e3351b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ORConsoleDetailHeaderFragment$data = {
  readonly name: string | null | undefined;
  readonly patientMrn: string | null | undefined;
  readonly plannedStart: any | null | undefined;
  readonly " $fragmentType": "ORConsoleDetailHeaderFragment";
};
export type ORConsoleDetailHeaderFragment$key = {
  readonly " $data"?: ORConsoleDetailHeaderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ORConsoleDetailHeaderFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ORConsoleDetailHeaderFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientMrn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "plannedStart",
      "storageKey": null
    }
  ],
  "type": "Surgery",
  "abstractKey": null
};

(node as any).hash = "414ea28a6a61e722da6b7c90eb059c27";

export default node;
